import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import classNames from 'classnames';
import { cloudinaryImageUrl, getImageHeight } from '@scentregroup/ui/tools/cloudinary/image';
import LazyLoad from 'react-lazyload';
import style from '../responsive-asset/index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_DESKTOP_BREAKPOINT = 641;

class ResponsiveImage extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "imageNode", /*#__PURE__*/React.createRef());

    _defineProperty(this, "onLoad", event => {
      if (this.props.onLoad) {
        this.props.onLoad(event);
      }
    });

    _defineProperty(this, "onError", event => {
      if (this.props.onError) {
        this.props.onError(event);
      }
    });
  }

  componentDidMount() {
    // Make sure onLoad is still fired if the image was already loaded via SSR
    if (this.imageNode.current && this.imageNode.current.complete) {
      this.onLoad();
    }
  }

  render() {
    const {
      className,
      desktopImageUrl,
      mobileImageUrl,
      mobileRatio,
      desktopRatio,
      desktopBreakpoint = DEFAULT_DESKTOP_BREAKPOINT,
      numberOfItems = 1,
      alt,
      lazyLoad,
      bgSize,
      width,
      dataTestId
    } = this.props;

    const placeholderElement = /*#__PURE__*/_jsx("div", {
      className: className,
      "data-id": "responsive-image_index_placeholderElement_div",
      children: /*#__PURE__*/_jsx("div", {
        className: classNames(style.placeholder, style["desktopRatio_".concat(desktopRatio)], style["mobileRatio_".concat(mobileRatio)]),
        "data-id": "responsive-image_index_placeholderElement_div_div_1"
      })
    }); // both desktop annd mobile urls are mandatory and have to be passed


    if (!desktopImageUrl || !mobileImageUrl) {
      return placeholderElement;
    }

    const pictureContent = /*#__PURE__*/_jsxs("picture", {
      className: classNames(style.ResponsiveAsset, className, style["desktopRatio_".concat(desktopRatio)], style["mobileRatio_".concat(mobileRatio)]),
      "data-test-id": dataTestId,
      "data-id": "responsive-image_index_placeholderElement_picture",
      children: [/*#__PURE__*/_jsx("source", {
        media: "(max-width: ".concat(desktopBreakpoint - 1, "px)"),
        srcSet: cloudinaryImageUrl({
          src: mobileImageUrl,
          ratio: mobileRatio,
          type: 'mobile',
          numberOfItems,
          bgSize,
          width
        }),
        "data-id": "responsive-image_index_placeholderElement_picture_source"
      }), /*#__PURE__*/_jsx("source", {
        media: "(min-width: ".concat(desktopBreakpoint, "px)"),
        srcSet: cloudinaryImageUrl({
          src: desktopImageUrl,
          ratio: desktopRatio,
          type: 'default',
          numberOfItems,
          bgSize,
          width
        }),
        "data-id": "responsive-image_index_placeholderElement_picture_source_4"
      }), /*#__PURE__*/_jsx("img", {
        className: style.ResponsiveAsset,
        ref: this.imageNode,
        src: cloudinaryImageUrl({
          src: desktopImageUrl,
          ratio: desktopRatio,
          type: 'default',
          numberOfItems,
          bgSize,
          width
        }),
        alt: alt,
        onLoad: this.onLoad,
        onError: this.onError,
        "data-id": "responsive-image_index_placeholderElement_picture_img"
      })]
    });

    return lazyLoad ? /*#__PURE__*/_jsx(LazyLoad, {
      offset: 800,
      height: getImageHeight({
        ratio: mobileRatio,
        type: 'default',
        numberOfItems
      }),
      "data-id": "responsive-image_index_placeholderElement_LazyLoad",
      children: pictureContent
    }) : pictureContent;
  }

}

_defineProperty(ResponsiveImage, "defaultProps", {
  alt: '',
  lazyLoad: true
});

export default ResponsiveImage;